/*
 * The account control in the top-right head band (main.html #loginPanelId).
 *
 * An avatar button that opens a dropdown — the shape every app the user already has open
 * uses for its account (Chrome's profile pill, Claude's account row). It replaced the inline
 * "Save my progress / Sign Out / Update Account" text band; the same links live on inside
 * the menu, so nothing was lost, only moved.
 *
 * Two states, decided by /api/auth/me:
 *   signed out (a temp user) — avatar = the silhouette, menu = one Sign in row (it carries the
 *                              garden sprout and the "why register" tooltip; a separate "Save my
 *                              progress" row lived beside it until sign-in and signing UP became
 *                              the same act — changeset 0103)
 *   signed in               — avatar = the account's initial, menu = Change account / Sign out
 * Both states get the Settings row, which flies out the application-wide settings submenu:
 * coarse vocabulary, Word list settings ◂ (the two fold switches) and Clock ◂ (time zone +
 * where their day starts). Every one of those rows opens on HOVER and every caret points ◂
 * left, because that is the side the boxes actually come out on.
 *
 * The markup is server-rendered in main.html so every label stays in the message bundle;
 * this file only shows, positions and wires it. Dismissal is entirely PL.layers' job — the
 * menu and its submenu are two stacked layers, so Esc peels one level at a time and an
 * outside click closes the whole stack.
 */
$(function () {

	var btn = $("#accountBtnId");
	if (!btn.length) {
		return;   // not the main page
	}

	var menu = $("#accountMenuId");
	var avatar = $("#accountAvatarId");
	var menuAvatar = $("#accountMenuAvatarId");
	var menuName = $("#accountMenuNameId");
	var signInLink = $("#accountSignInId");
	var updateLink = $("#accountUpdateId");
	var signOutLink = $("#accountSignOutId");
	var settingsRow = $("#accountSettingsId");
	var subEl = $("#accountSettingsMenuId");
	var wordListsRow = $("#accountWordListsId");
	var wordListsEl = $("#accountWordListsMenuId");
	var clockRow = $("#accountClockId");
	var clockEl = $("#accountClockMenuId");
	var clockNow = $("#accountClockNowId");

	// The server-rendered "Guest" (#{main.label.guest}) — held so a sign-out can put it back.
	var guestLabel = menuName.text();

	// Sign out is a POST since 2026-09-02 (go-public-hardening §3 F13 — a state-changing GET is
	// something any other page can make this browser follow). The row stays an <a> for its layout
	// and keyboard behaviour and its href is "#"; the click submits main.html's hidden
	// #logoutFormId, which is what actually carries the request.
	signOutLink.on("click", function (e) {
		e.preventDefault();
		var form = $("#logoutFormId");
		if (form.length) {
			form.get(0).submit();
		}
	});

	var menuLayer = null;   // the open dropdown's PL.layers handle (null = closed); each flyout
	                        // below keeps its own inside flyout()

	// ── State ───────────────────────────────────────────────────────────────────────────
	// Both rows of each pair are in the DOM from the start; exactly one pair shows.
	// NB the rows are flex (icon + label), so they are revealed with an explicit
	// display:flex — jQuery's .show() would restore the <a>'s default display:inline
	// and quietly undo the row layout (docs/feedback/jquery-show-breaks-flex.md).

	function showRow(el, visible) {
		el.css("display", visible ? "flex" : "none");
	}

	function showSignedOut() {
		menuName.text(guestLabel);
		paintAvatar(null);
		showRow(signInLink, true);
		showRow(updateLink, false);
		showRow(signOutLink, false);
		// The persistent low-key signup affordance (onboarding-tour.md §5): says WHY, not just
		// WHAT — the one-time nudge card lives in onboarding.js, this row stays. Its garden
		// sprout ties signing in to the garden the nudge talked about. It rode on a separate
		// "Save my progress" row until changeset 0103 collapsed the two signed-out rows into one;
		// the affordance moved onto the survivor rather than going with it.
		signInLink.assignTooltip("signupOptional_tooltip");
		if (!signInLink.find(".obSaveSproutClass").length) {
			// TRIAL (2026-08-13): the 🌱 U+1F331 glyph in place of tab-sprout.svg, in step with
			// the Learn tab and GARDEN.markIcon. Class unchanged; the stylesheets size the span
			// separately from the <img> so the swap reverts in one line.
			signInLink.find(".accountMenuIcoClass")
				.append('<span class="obSaveSproutClass" aria-hidden="true">🌱</span>');
		}
	}

	function showSignedIn(username) {
		menuName.text(username);
		paintAvatar(username);
		showRow(signInLink, false);
		showRow(updateLink, true);
		showRow(signOutLink, true);
	}

	// The avatar is the same element twice (button + menu head): a silhouette while signed
	// out, the account's initial once there is a name to show.
	function paintAvatar(username) {
		var initial = username ? username.trim().charAt(0) : "";
		$.each([avatar, menuAvatar], function (_, el) {
			el.toggleClass("accountAvatarNamedClass", !!initial);
			el.html(initial ? $("<span></span>").text(initial) : plIcon("user-round"));
		});
	}

	$.ajax("/api/auth/me", {
		type: "GET",
		dataType: "json",
		success: function (data) {
			if (data && !data.tempUser) {
				showSignedIn(data.username);
			} else {
				showSignedOut();
			}
		},
		error: showSignedOut
	});

	// ── Placement ───────────────────────────────────────────────────────────────────────
	// Everything hangs off <body>, so the narrow head band (and the pane's own overflow)
	// can never clip it. Right edges align with the anchor and the box grows leftward —
	// the control sits at the window's right edge, so there is nowhere else to grow.

	function placeUnder(el, anchorEl) {
		var r = anchorEl.getBoundingClientRect();
		el.css({
			top: (r.bottom + window.scrollY + 6) + "px",
			right: Math.max(8, window.innerWidth - r.right) + "px",
			left: ""
		});
	}

	// A flyout sits beside its parent row, top-aligned with it, opening LEFTWARD past the
	// parent menu's left edge. Both clamps exist because the stack is now three deep (menu ▸
	// Settings ▸ Clock): each level travels another box-width left and down its parent's row,
	// so on a small window the third would otherwise walk off the left edge or below the fold.
	// Overlapping the parent is the graceful failure; leaving the viewport is not.
	function placeBeside(el, parentMenuEl, rowEl) {
		var pr = parentMenuEl.getBoundingClientRect();
		var rr = rowEl.getBoundingClientRect();
		var right = Math.min(window.innerWidth - pr.left + 4, window.innerWidth - el.outerWidth() - 8);
		var top = Math.min(rr.top + window.scrollY - 6,
			window.scrollY + window.innerHeight - el.outerHeight() - 8);
		el.css({
			top: Math.max(window.scrollY + 8, top) + "px",
			right: Math.max(8, right) + "px",
			left: ""
		});
	}

	// ── The dropdown ────────────────────────────────────────────────────────────────────

	function openMenu() {
		if (menuLayer) {
			return;
		}
		$("body").append(menu);            // first open moves it out of the head band for good
		menu.css("display", "block");
		placeUnder(menu, btn[0]);
		btn.attr("aria-expanded", "true");
		menuLayer = PL.layers.push({
			el: menu[0],
			anchors: [btn[0]],             // the toggling click must not dismiss-then-reopen
			onClose: function () {
				menuLayer = null;
				menu.hide();
				btn.attr("aria-expanded", "false");
			}
		});
	}

	function closeMenu() {
		if (menuLayer) {
			menuLayer.close("api");
		}
	}

	btn.click(function (e) {
		e.stopPropagation();
		if (menuLayer) {
			closeMenu();
		} else {
			openMenu();
		}
	});

	// Picking any auth row is a navigation — let the <a> do its work, just close first so a
	// slow page load does not leave a menu hanging over it.
	menu.find("a.accountMenuItemClass").click(function () {
		closeMenu();
	});

	// (A "Send feedback" row was wired here until 2026-08-17. The owner moved the channel out of
	// this menu — its doors are the tabs-row 💬, the finish screen and the Learn screens, all owned
	// by feedback.js. Nothing feedback-related is left in this file.)

	// ── Flyouts ─────────────────────────────────────────────────────────────────────────
	// Settings ▸ off the menu, and Clock ▸ off Settings, are the same thing at two depths: a
	// parent row that toggles a server-rendered box which hangs off <body> and is dismissed by
	// PL.layers. Closing an outer layer cascades into the inner one, so neither level has to
	// know what it hangs from — which is the whole reason a third level cost nothing.
	//
	// `beforeOpen` runs while the box is still hidden and BEFORE the placement, because what it
	// writes (the zone option list, the row's clock, which switches this pair can even use)
	// decides how wide and how tall the box ends up.
	//
	// `opts.hover` adds the submenu behaviour proper: the row opens on hover and the box closes
	// when the pointer leaves BOTH of them (PL.hover.intent's 150ms intent / 600ms grace, so a
	// diagonal path from the row into the box survives). EVERY level is on hover since 2026-08-18
	// (owner call) — no sub-parent row here decides anything of its own, it exists only to hold
	// the box, so making any of them a click was a press for nothing. Clicking still toggles,
	// through the same machine, so the keyboard path is unchanged.
	//
	// `opts.suspended` is passed straight to the machine: while it says true the close grace
	// neither schedules nor fires. See fieldFocused() below for the one thing that needs it.
	//
	// SIBLINGS ARE EXCLUSIVE. PL.layers stacks rather than replaces, so two flyouts off the SAME
	// box would simply both be on screen, overlapping — which nobody noticed while Settings had
	// exactly one submenu. Opening one now closes the other, which is also what makes the hover row
	// safe to add: a pointer wandering down the Settings box must not leave a trail of open boxes.

	var flyouts = [];

	function flyout(boxEl, rowEl, parentEl, beforeOpen, opts) {
		var layer = null;
		var self = {
			parent: parentEl[0], box: boxEl[0],
			close: function () { if (layer) { layer.close("api"); } }
		};
		flyouts.push(self);

		function open() {
			if (layer) {
				return;
			}
			$.each(flyouts, function (_, other) {
				if (other !== self && other.parent === self.parent) { other.close(); }
			});
			$("body").append(boxEl);       // first open moves it out of the head band for good
			if (beforeOpen) {
				beforeOpen();
			}
			boxEl.css("display", "block");
			placeBeside(boxEl, parentEl[0], rowEl[0]);
			rowEl.addClass("accountSubOpenClass").attr("aria-expanded", "true");
			layer = PL.layers.push({
				el: boxEl[0],
				anchors: [rowEl[0]],       // the toggling click must not dismiss-then-reopen
				onClose: function () {
					layer = null;
					boxEl.hide();
					rowEl.removeClass("accountSubOpenClass").attr("aria-expanded", "false");
				}
			});
		}

		// One machine for the row AND the box, so leaving one into the other never closes it.
		// isOpen() reads the layer rather than any state of its own — Esc and outside clicks go
		// through PL.layers and would otherwise leave the machine believing the box is still up.
		var machine = (opts && opts.hover) ? PL.hover.intent({
			open: open,
			close: function () { if (layer) { layer.close("api"); } },
			isOpen: function () { return !!layer; },
			suspended: opts.suspended
		}) : null;
		self.machine = machine;
		if (machine) {
			machine.bind(rowEl[0]).bind(boxEl[0]);
			// …AND this box feeds its PARENT's machine as well. Reaching into a submenu means
			// leaving the box that holds its row, so without this the parent starts its own close
			// grace the moment the pointer arrives here, and a second later folds — taking this box
			// down with it, out from under a pointer that was on its way to a checkbox. "Inside" has
			// to mean the whole open branch, not one box of it.
			$.each(flyouts, function (_, other) {
				if (other.box === parentEl[0] && other.machine) {
					other.machine.bind(boxEl[0]);
				}
			});
		}

		rowEl.click(function (e) {
			e.stopPropagation();
			if (machine) {
				machine.toggle();      // cancels a pending hover-open first — see PL.hover's note
			} else if (layer) {
				layer.close("api");
			} else {
				open();
			}
		});

		rowEl.keydown(function (e) {
			if (e.which === PL.keys.ENTER || e.which === PL.keys.SPACE) {
				e.preventDefault();
				rowEl.click();
			}
		});

		// The suspension's release valve: while it held, the pointer's exit was swallowed rather
		// than queued, so the level would otherwise stand open with nothing on it. Only ever
		// called once the suspension is over AND the pointer is genuinely elsewhere.
		self.leave = function () { if (machine) { machine.leave(); } };
		return self;
	}

	// A native <select> popup is drawn OUTSIDE the page, so a pointer travelling into the option
	// list reads as it leaving every box in the stack at once. While one has focus no level may
	// close on hover — not just the box the select is in: an outer level that folded would cascade
	// its child shut anyway, which is exactly how the Clock box first vanished under its own list.
	function fieldFocused() {
		var active = document.activeElement;
		return !!active && active.tagName === "SELECT"
			&& !!$(active).closest(".accountMenuClass").length;
	}

	// Settings ◂ — the languages keep their own pills in this pane and the drill keeps its own ⚙
	// dialog, so this holds only what belongs to the whole app and fits neither. It re-asks the
	// Word Lists panel on every open, because whether the "Word list settings ◂" row belongs in
	// this box at all depends on the language pair currently on screen.
	var settingsFly = flyout(subEl, settingsRow, menu, function () {
		stampClockNow();
		syncCompactSwitches();
	}, { hover: true, suspended: fieldFocused });

	// Clock ◂ — time zone + where the day starts, two settings that are one idea. They sat in the
	// Settings box itself until 2026-08-04; full-width selects among a list of switches made it
	// read as a form rather than a menu, and the pair earns a row of its own.
	var clockFly = flyout(clockEl, clockRow, subEl, buildZoneOptions,
		{ hover: true, suspended: fieldFocused });

	// Leaving the selects behind ends the suspension — and the pointer's exit was swallowed while
	// it held, so nothing would ever ask these two levels to close. Deferred a tick because focus
	// is briefly on nothing between one field and the next, and :hover rather than a tracked
	// pointer because a user still inside the box has not left it, whatever focus is doing.
	// NB the native matches(), not jQuery's .is() — Sizzle dropped :hover and throws on it.
	function pointerOver(el) {
		return !!el.length && el[0].matches(":hover");
	}

	clockEl.on("focusout", function () {
		setTimeout(function () {
			if (fieldFocused() || pointerOver(clockEl) || pointerOver(clockRow)) {
				return;
			}
			clockFly.leave();
			if (!pointerOver(subEl) && !pointerOver(settingsRow)) {
				settingsFly.leave();
			}
		}, 0);
	});

	// Word list settings ◂ — the two fold switches, one per group of built-in rows.
	flyout(wordListsEl, wordListsRow, subEl, syncCompactSwitches,
		{ hover: true, suspended: fieldFocused });

	// ── Compact dictionary lists / compact verb lists ───────────────────────────────────
	// Fold the Word Lists panel's five dictionary-level rows into one A–E strip, and its two verb
	// rows into their own. ONE switch did both until 2026-08-18. The flyout stays OPEN on toggle:
	// the panel redraws behind it, so leaving the switch under the pointer is what lets the user
	// see what they just did (and undo it in one more click). The panel owns the redraw — this
	// only writes the global, persists it, and says so.
	//
	// The double-click on a row's kind icon is the OTHER way to throw either switch, and it fires
	// the same event from the panel's side — hence syncCompactSwitches, so the boxes can never
	// stand at a state the panel has already left.

	var COMPACT_SWITCHES = [
		{ box: $("#compactLevelListsId"), row: $("#accountCompactLevelsId"),
		  global: "compact_level_lists", attr: "compactLevelLists" },
		{ box: $("#compactVerbListsId"), row: $("#accountCompactVerbsId"),
		  global: "compact_verb_lists", attr: "compactVerbLists" }
	];

	$.each(COMPACT_SWITCHES, function (_, s) {
		s.box.change(function () {
			window[s.global] = this.checked;
			ajaxPostUserAttr(s.attr, this.checked);
			$(document).trigger("pl:compactLists");
		});
		// The row is a <label>, so a click already toggles the box. Stop it reaching the layer
		// stack, which would read a click on the flyout's own row as an outside click on the
		// menu beneath it.
		s.row.click(function (e) {
			e.stopPropagation();
		});
	});

	// Read the switches back off the globals, and drop a switch this language pair cannot use —
	// only the Word Lists panel knows how many rows a group has, and folding one row into one
	// strip row is a control that does nothing. .prop() deliberately, not .click(): setting the
	// box must not fire `change` and re-persist what we just read.
	function syncCompactSwitches() {
		var any = false;
		$.each(COMPACT_SWITCHES, function (_, s) {
			s.box.prop("checked", !!window[s.global]);
			var usable = !window.plWlPanel || window.plWlPanel.foldable(s.attr);
			showRow(s.row, usable);
			any = any || usable;
		});
		// …and if neither switch applies to this pair, the row that holds them goes too. A menu
		// row that opens an empty box is worse than one that is not there.
		showRow(wordListsRow, any);
	}

	// Fired by the checkbox handlers above AND by a double-click on a panel row's kind icon.
	$(document).on("pl:compactLists", syncCompactSwitches);

	// ── Include vulgar words ──────────────────────────────────
	// docs/project/vulgar-slur-handling.md, P3. Every gate is server-side — the client neither
	// knows nor decides which words the class holds. What it must do is FORGET: rich entries are
	// cached per page under (pair|word), and the senses inside them are exactly what the setting
	// changes, so a cache kept across a toggle would go on answering in the old shape.

	$("#includeVulgarId").change(function () {
		window.include_vulgar = this.checked;
		ajaxPostUserAttr("includeVulgar", this.checked);
		$(document).trigger("pl:includeVulgar");
	});

	$("#accountIncludeVulgarId").click(function (e) {
		e.stopPropagation();
	});

	// ── The user's clock: time zone + where the day starts ──────────────────────────────
	// Two rows, one idea (docs/project/learning-day-boundary.md): the app DETECTS and states
	// what it found, and the user corrects it if it is wrong. Neither is ever asked on the way
	// in — a zone question at the door is a question almost every user would answer with the
	// value we already have. The zone row therefore OPENS on "Detected: Europe/Berlin · 14:32",
	// with the local time beside it as the proof that tells right from wrong at a glance, and
	// the boundary row opens on its 03:00 default.
	//
	// Both live one level down, behind the Clock ▸ row, which carries the same proof in miniature:
	// the current time in the zone actually in force. A user who only wants to CHECK the setting
	// reads it off the Settings box and never opens anything.

	var tzSelect = $("#tzOverrideId");
	var dayStartSelect = $("#dayStartHourId");
	var detectedZone = "";
	try {
		detectedZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
	} catch (e) {
		detectedZone = "";
	}

	// Keep the detection fresh on the server: the surfaces with no request-carried zone (the
	// garden band, the thirsty chip, the difficult-words nag) read the remembered one. Written
	// only when it actually changed — a moved laptop, or a visitor who has never drilled and
	// so has never sent one with a session start.
	//
	// ⛔ Never on the GUEST page (/<locale>/<learn>/app, entry-flow-redesign.md §3.3): this is the
	// one WRITE among that page's load-time requests, and there is no user to write it to. The
	// server answers a guest {} rather than 401 in any case, but a request whose whole purpose is
	// to be discarded is one not to make — and the zone is re-detected on the very next load,
	// which for this page is the moment the tour card mints a user.
	if (!window.guest_mode && detectedZone && detectedZone !== window.tz_stored) {
		window.tz_stored = detectedZone;
		ajaxPostUserAttr("tz", detectedZone);
	}

	// 24-hour, in the UI's language — NOT the browser's. Left to the browser this read "09:52 PM"
	// one row above a day-boundary select that offers "03:00", and in a Russian UI at that.
	function localTimeIn(zone) {
		try {
			return new Date().toLocaleTimeString(localeTag(), {
				timeZone: zone, hour: "2-digit", minute: "2-digit", hourCycle: "h23"
			});
		} catch (e) {
			return "";
		}
	}

	// The zone actually in force — the override if there is one, otherwise what the browser said.
	function effectiveZone() {
		return window.tz_override || detectedZone || "UTC";
	}

	// The Clock ▸ row's value. Re-stamped every time the Settings box opens (a clock in a menu is
	// stale the moment it is written) and after a zone change, which happens with the row in view.
	function stampClockNow() {
		clockNow.text(localTimeIn(effectiveZone()));
	}

	var zonesBuilt = false;

	// "Detected: Europe/Berlin · 14:02" — the row's own value. Composed on every read and never
	// cached, because the clock in it moves.
	function detectedLabel() {
		var shown = detectedZone || "UTC";
		var time = localTimeIn(shown);
		return (getRes("tzDetected_text") || "Detected") + ": " + shown + (time ? " · " + time : "");
	}

	// The zone list can only come from the browser, so this is the one row of the flyout that is
	// not server-rendered. Built once, on first open; the detected label is re-stamped every time
	// because the clock in it moves.
	function buildZoneOptions() {
		if (!tzSelect.length) {
			return;
		}
		tzSelect.find("option[value='']").text(detectedLabel());
		if (zonesBuilt) {
			return;
		}
		zonesBuilt = true;
		// A tooltip as well as the option text: a long zone id clips in the closed select, and the
		// whole point of this row is that the user can READ what was detected. It was a native
		// title= until PR 7/7 of the tooltip engine (design §6, #15) — bound once here, with the
		// label resolved at HOVER time, so the clock in it is current every time it opens.
		// guided:false: this reads out a detected value rather than explaining the control, and a
		// sticky 20em panel inside the Settings flyout would cover the rows under it.
		PL.tip.attach(tzSelect, {
			content: detectedLabel, guided: false,
			on: function (el, name, fn) { $(el).on(name, fn); }
		});
		var zones = [];
		try {
			zones = Intl.supportedValuesOf("timeZone") || [];
		} catch (e) {
			zones = [];
		}
		if (!zones.length) {
			// A browser too old to enumerate zones still gets a working row: it can see the
			// override it has and clear it back to the detection.
			zones = detectedZone ? [detectedZone, "UTC"] : ["UTC"];
		}
		if (window.tz_override && $.inArray(window.tz_override, zones) < 0) {
			zones.push(window.tz_override);   // a stored value this browser's list does not know
		}
		$.each(zones, function (_, zone) {
			tzSelect.append($("<option></option>").attr("value", zone).text(zone));
		});
		tzSelect.val(window.tz_override || "");
	}

	// Both settings decide which day a session counted on, so the progress panel is stale the
	// moment either changes — the streak and the "Today" line are the visible half of the rule.
	// Like the compact toggle, the flyout stays OPEN: the panel repaints behind it, which is what
	// lets the user see what they just did and undo it in one more click.
	function afterClockChange() {
		if (window.refreshStats) {
			window.refreshStats();
		}
	}

	tzSelect.change(function () {
		window.tz_override = this.value;
		ajaxPostUserAttr("tzOverride", this.value);
		stampClockNow();   // the Clock ▸ row is still on screen, one box to the right
		afterClockChange();
	});

	dayStartSelect.change(function () {
		ajaxPostUserAttr("dayStartHour", this.value);
		afterClockChange();
	});

	// Same reason as the checkbox row above — a click inside the flyout must not read as an
	// outside click on the menu beneath it.
	$("#accountTimeZoneId, #accountDayStartId").click(function (e) {
		e.stopPropagation();
	});

	// On the LABEL rather than the whole row: a tooltip that opens while the user is aiming at
	// the select is noise, and these two say WHY the setting exists, which is only worth reading
	// once.
	$("#accountTimeZoneId").find(".accountMenuLabelClass").assignTooltip("settingsTimeZone_tooltip");
	$("#accountDayStartId").find(".accountMenuLabelClass").assignTooltip("settingsDayStart_tooltip");

	// A resize would leave every open layer pointing at where the button used to be.
	$(window).resize(function () {
		closeMenu();
	});
});
